
import Vue, { CreateElement } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import ILink from '@frontend/types/base/ILink';

@Component({
	componentId: 'link-component'
})
export default class LinkComponent extends Vue {
	@Prop(Object)
	protected readonly link!: ILink;

	render(createElement: CreateElement) {
		return createElement(
			'a',
			{
				attrs: {
					href: this.link.url,
					target: this.link.target,
					rel: this.link.target === '_blank' ? 'noreferrer noopener' : null,
					lang: this.link.lang,
					hreflang: this.link.hreflang,
					'aria-label': this.link.ariaLabel
				}
			},
			this.$slots.default ? this.$slots.default : this.link.label
		);
	}
}
